import React from 'react';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';
import t from '@jetshop/intl';
import { theme } from '../Theme';
import { isRelativeUrl } from '@jetshop/core/helpers/isRelativeUrl';
import ButtonUI from '@jetshop/ui/Button';

export const baseStyles = css`
  display: inline-flex;

  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.accent};
  border-color: ${theme.colors.accent};
  color: white;
  font-size: 16px;
  padding: 0px 30px;
  height: 35px;
  font-size: calc(12rem / 16);
  font-weight: 600;
  letter-spacing: 0.1em;
  span {
    margin-right: 12px;
  }
  svg {
    fill: white;
    height: 1em;
    width: 1em;
    margin-right: 1em;
  }
  ${theme.above.md} {
    max-width: 100%;
  }

  :disabled {
    border: 1px solid #dedede;
    opacity: 0.5;
  }

  &.black {
    align-self: center;
    width: 100%;
    padding: 13px 30px 10px 30px;
    border-radius: 0;
    background: ${theme.colors.black};
    max-width: 240px;
  }
`;

const BaseButton = styled('button')``;

const TrendABase = styled('a')`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const TrendLinkBase = styled(Link)`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const StyledButton = styled(ButtonUI)``;

const ButtonLink = styled(Link)`
  text-decoration: none;
`;

export function TrendLink({ to, ...props }) {
  return typeof to === 'string' && !isRelativeUrl(to) ? (
    <TrendABase href={to} {...props} />
  ) : (
    <TrendLinkBase to={to} {...props} />
  );
}

const StyledSpinner = styled(Spinner)`
  height: 25px;
  circle.path {
    stroke: white;
  }
`;

export const Button = ({
  className = '',
  secondary = false,
  outline = false,
  link = '',
  ...props
}) => {
  return link !== '' && isRelativeUrl(link) ? (
    <ButtonLink
      to={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  ) : (
    <StyledButton
      anchor={link !== ''}
      href={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  );
};

const ButtonWithLoading = ({
  loading,
  loadingText = t('Hold on a moment...'),
  secondary,
  className,
  ...props
}) =>
  loading ? (
    <BaseButton
      {...props}
      className={cx(baseStyles, secondary && secondaryStyle, className)}
    >
      <span>{loadingText}</span>
      <StyledSpinner />
    </BaseButton>
  ) : (
    <BaseButton
      {...props}
      className={cx(baseStyles, secondary && secondaryStyle, className)}
    />
  );

export default ButtonWithLoading;

const secondaryStyle = css`
  background-color: white;
  color: ${theme.colors.darkgrey};
  circle.path {
    stroke: black;
  }
`;

const outlineStyle = css`
  background-color: transparent;
  &.${secondaryStyle} {
    border: 1px solid ${theme.colors.white};
    color: ${theme.colors.white};
    &:hover {
      background-color: ${theme.colors.white};
      color: ${theme.colors.black};
    }
  }
  &:not(.${secondaryStyle}) {
    border: 1px solid ${theme.colors.black};
    color: ${theme.colors.black};
    &:hover {
      background-color: ${theme.colors.black};
      color: ${theme.colors.white};
    }
  }
`;
